import axios from 'axios';
import { CHECKOUT_BASE } from "../config/env";
const api = axios.create({
  baseURL: CHECKOUT_BASE,
  headers: {
    "Accept-Language": "tr-tr",
    "Content-Type": "application/json",
    "Cart-Type": "fast-checkout",
    "App-Version": "1.3",
  },
});
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem("accessToken");
    const clientId = localStorage.getItem("Client-Id");
    const oneId = localStorage.getItem("One-Id");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (clientId) {
      config.headers["Client-Id"] = clientId;
    }

    if (oneId) {
      config.headers["One-Id"] = oneId;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
export default api;
